import '../create_team_tab_content/index_web.css';
import { View, Text, FlatListWrapper } from '../../../component';
import useTheme from '../../../utilities/hooks/theme';
import I18n from '../../../utilities/locale';
import TeamSorting from '../team_sorting';
import FlatList from 'flatlist-react';
import SubstituteTeamPlayerRow from '../substitute_team_player_row';
import React from 'react';

interface Props {
  data: any;
  matchItem: any;
  onPressPlayer: any;
  selectedTab: number;
  renderWhenEmpty: any;
  keeperList: any;
  batsmanList: any;
  allRounderList: any;
  bowlerList: any;
  sortName: any;
  sortType: any;
  onUpdateSortingList: any;
  lineupsOut: boolean;
  keeperListDisable: boolean;
  batsmanListDisable: boolean;
  allRounderListDisable: boolean;
  bowlerListDisable: boolean;
  teamAPlayersCount: number;
  teamBPlayersCount: number;
  totalCreditCount: number;
  theme: any;
  oldPlayerData: any;
  substitutedPlayers: any;
  teamASInningsPlayerCount: number;
  teamBSInningsPlayerCount: number;
  substitutionPlayers: any;
}

const SubstituteTeamTabContent = ({
  data,
  matchItem,
  onPressPlayer,
  selectedTab,
  renderWhenEmpty,
  keeperList,
  batsmanList,
  allRounderList,
  bowlerList,
  sortName,
  sortType,
  onUpdateSortingList,
  lineupsOut,
  keeperListDisable,
  batsmanListDisable,
  allRounderListDisable,
  bowlerListDisable,
  teamAPlayersCount,
  teamBPlayersCount,
  totalCreditCount,
  oldPlayerData,
  substitutedPlayers,
  teamASInningsPlayerCount,
  teamBSInningsPlayerCount,
  substitutionPlayers
}: Props) => {
  const { FantasyTheme: theme } = useTheme();
  const renderItemPlayer = (item: any) => (
    <SubstituteTeamPlayerRow
      item={item}
      matchItem={matchItem}
      key={item.id}
      onPressPlayer={onPressPlayer}
      lineupsOut={lineupsOut}
      keeperListDisable={keeperListDisable}
      batsmanListDisable={batsmanListDisable}
      allRounderListDisable={allRounderListDisable}
      bowlerListDisable={bowlerListDisable}
      teamAPlayersCount={teamAPlayersCount}
      teamBPlayersCount={teamBPlayersCount}
      totalCreditCount={totalCreditCount}
      oldPlayerData={oldPlayerData}
      substitutedPlayers={substitutedPlayers}
      teamASInningsPlayerCount={teamASInningsPlayerCount}
      teamBSInningsPlayerCount={teamBSInningsPlayerCount}
      substitutionPlayers={substitutionPlayers}
    />
  );

  const pick1 = {
    color: theme.createTeamSelectPlayerTitle
  };

  const pickLabel =
    selectedTab === 0
      ? I18n.t('PickWicketKeeper')
      : selectedTab === 1
      ? I18n.t('PickBatsman')
      : selectedTab === 2
      ? I18n.t('PickAllRounder')
      : I18n.t('PickBowler');

  const pickLabelMessage =
    selectedTab === 0
      ? I18n.t('PickWicketKeeperMaxMessage')
      : selectedTab === 1
      ? I18n.t('PickWicketBatsmanMaxMessage')
      : selectedTab === 2
      ? I18n.t('PickWicketKeeperMaxMessage')
      : I18n.t('PickWicketBatsmanMaxMessage');
  return (
    <View className={'create-team-tab-content-wrapper'}>
      <View className={'create-team-tab-content-pick-player-wrapper'}>
        <Text className={'create-team-tab-content-pick-label'} style={pick1}>
          {`${pickLabel}`}
        </Text>
        <Text className={'create-team-tab-content-pick-message'} style={pick1}>
          &nbsp;&nbsp;-&nbsp;&nbsp;{pickLabelMessage}
        </Text>
      </View>

      <View className={'create-team-tab-content-sorting-header'}>
        <TeamSorting
          keeperList={keeperList}
          batsmanList={batsmanList}
          allRounderList={allRounderList}
          bowlerList={bowlerList}
          sortName={sortName}
          sortType={sortType}
          onUpdateSortingList={onUpdateSortingList}
        />
      </View>

      <View className={'create-team-tab-content-flatlist'}>
        <div className="flat-list-outer">
          <FlatListWrapper>
            <FlatList
              list={data}
              renderItem={renderItemPlayer}
              renderOnScroll
              renderWhenEmpty={renderWhenEmpty}
            />
          </FlatListWrapper>
        </div>
      </View>
    </View>
  );
};
export default React.memo(SubstituteTeamTabContent);
